import { useState } from "react";
import { Phone, Loader2, Check } from "lucide-react";
import { toast } from "sonner";
import api from "../lib/api";

/**
 * Händler-Verwaltung der Inserats-Tracking-Nummer. Weist eine echte Nummer aus
 * dem Plattform-Pool zu bzw. gibt sie frei. Sichtbar nur für den Inserat-Besitzer.
 * Ist kein Pool hinterlegt, meldet die Zuweisung „keine Nummer verfügbar" —
 * es wird nie eine tote Nummer angezeigt.
 */
export default function TrackingNumberManager({ listing, onUpdate }) {
    const [busy, setBusy] = useState(false);
    const active = listing.tracking_number;

    const assign = async () => {
        setBusy(true);
        try {
            const { data } = await api.post(`/listings/${listing.id}/tracking-number`);
            toast.success(`Tracking-Nummer aktiviert: ${data.tracking_number}`);
            if (onUpdate) await onUpdate();
        } catch (e) {
            toast.error(e?.response?.data?.detail || "Keine Tracking-Nummer verfügbar");
        } finally {
            setBusy(false);
        }
    };

    const release = async () => {
        setBusy(true);
        try {
            await api.delete(`/listings/${listing.id}/tracking-number`);
            toast.success("Tracking-Nummer freigegeben");
            if (onUpdate) await onUpdate();
        } catch {
            toast.error("Freigabe fehlgeschlagen");
        } finally {
            setBusy(false);
        }
    };

    return (
        <div className="border border-dashed border-gray-300 rounded-sm p-3 bg-gray-50" data-testid="tracking-number-manager">
            <div className="text-[11px] font-bold uppercase tracking-wider text-gray-600 flex items-center gap-1.5 mb-1">
                <Phone className="w-3.5 h-3.5" /> Tracking-Nummer (nur für Sie sichtbar)
            </div>
            {active ? (
                <div className="flex items-center justify-between gap-2">
                    <div className="text-sm">
                        <span className="inline-flex items-center gap-1 text-emerald-700 font-bold"><Check className="w-3.5 h-3.5" /> Aktiv</span>
                        <span className="ml-2 font-mono-num text-[#111827]">{active}</span>
                        <div className="text-[11px] text-gray-500 mt-0.5">Anrufe zu diesem Inserat werden automatisch erkannt und zugeordnet.</div>
                    </div>
                    <button onClick={release} disabled={busy} className="text-[11px] font-bold uppercase tracking-wider text-red-600 hover:underline shrink-0" data-testid="tracking-release-btn">
                        {busy ? "…" : "Freigeben"}
                    </button>
                </div>
            ) : (
                <div className="flex items-center justify-between gap-2">
                    <div className="text-xs text-gray-600">Zeigt Interessenten eine eigene Nummer für dieses Fahrzeug — Anrufe werden automatisch erkannt.</div>
                    <button onClick={assign} disabled={busy} className="inline-flex items-center gap-1.5 px-3 py-1.5 bg-[#111827] hover:bg-black text-[#FFCC00] text-[11px] font-bold uppercase tracking-wider rounded-sm shrink-0" data-testid="tracking-assign-btn">
                        {busy ? <Loader2 className="w-3.5 h-3.5 animate-spin" /> : "Aktivieren"}
                    </button>
                </div>
            )}
        </div>
    );
}
